import { render, staticRenderFns } from "./error-tick.vue?vue&type=template&id=6e450cb2&"
import script from "./error-tick.vue?vue&type=script&lang=js&"
export * from "./error-tick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e450cb2')) {
      api.createRecord('6e450cb2', component.options)
    } else {
      api.reload('6e450cb2', component.options)
    }
    module.hot.accept("./error-tick.vue?vue&type=template&id=6e450cb2&", function () {
      api.rerender('6e450cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/svg/error-tick.vue"
export default component.exports